// extracted by mini-css-extract-plugin
export default {"default":"Bubble_default__QbfCJ","userHolder":"Bubble_userHolder__Mb6M9","user":"Bubble_user__srCrl"};